/* eslint-disable no-magic-numbers */
import {
  type BulkUpdateExpensesResponseAPI,
  ExpenseCategoryEnum,
  ExpenseStatusEnum,
  type ExpensesConfigAPI,
  ExpensesEditingMethod,
  type GetExpenseResponseAPI,
  type GetExpensesResponseAPI,
} from '@omnipresentgroup/types';

export const DEFAULT_EXPENSE_DETAILS: GetExpenseResponseAPI = {
  category: ExpenseCategoryEnum.STAFF_ENTERTAINMENT,
  amount: {
    amount: 3000,
    currency: 'GBP',
  },
  status: ExpenseStatusEnum.INFO_NEEDED,
  status_history: [
    {
      status_changed_at: '2023-05-18T19:28:36.307Z',
      status_changed_by: 'def2967b-f6fa-48a7-82f0-cf56ecd8b5a7',
      status: ExpenseStatusEnum.PENDING,
    },
  ],
  requested_change: '',
  rejection_reason: '',
  approver_seen: false,
  reported: false,
  id: '1307adc9-1cfb-4be0-84a5-d1093854bd63',
  employee_id: 'def2967b-f6fa-48a7-82f0-cf56ecd8b5a7',
  employee_name: 'Roy',
  approver_id: 'adc8745b-f6fa-48a7-82f0-cf82ecd8b7t4',
  approver_name: 'E2e Manager',
  title: 'Test expense',
  description: 'Test description',
  document_id: 'f606862a-1a48-4d24-8070-90f30263b243',
  created_at: '2023-05-18T19:28:36.307Z',
  date_spent: '2022-07-27T00:00:00.000Z',
};

export const DEFAULT_EXPENSES: GetExpensesResponseAPI = {
  items: [
    {
      category: ExpenseCategoryEnum.STAFF_ENTERTAINMENT,
      amount: {
        amount: 3000,
        currency: 'GBP',
      },
      status: ExpenseStatusEnum.PENDING,
      id: '1307adc9-1cfb-4be0-84a5-d1093854bd63',
      employee_id: 'def2967b-f6fa-48a7-82f0-cf56ecd8b5a7',
      employee_name: 'Roy',
      approver_id: 'adc8745b-f6fa-48a7-82f0-cf82ecd8b7t4',
      approver_name: 'E2e Manager',
      title: 'Test expense',
      description: 'Test description',
      date_spent: '2022-07-27T00:00:00.000Z',
      reported: false,
      status_history: [
        {
          status_changed_at: '2023-05-18T19:28:36.307Z',
          status_changed_by: 'def2967b-f6fa-48a7-82f0-cf56ecd8b5a7',
          status: ExpenseStatusEnum.PENDING,
        },
      ],
    },
    {
      category: ExpenseCategoryEnum.CLIENT_ENTERTAINMENT,
      amount: {
        amount: 90,
        currency: 'CAD',
      },
      status: ExpenseStatusEnum.APPROVED,
      id: '0853d55b-3070-4d34-aa42-3fed8f893d85',
      employee_id: 'def2967b-f6fa-48a7-82f0-cf56ecd8b5a7',
      employee_name: 'Roy Testing Sr. Testertonww',
      approver_id: 'adc8745b-f6fa-48a7-82f0-cf82ecd8b7t4',
      approver_name: 'E2E Manager',
      title: 'test12345',
      description: 'abc',
      date_spent: '2022-11-07T05:00:00.000Z',
      reported: true,
      status_history: [
        {
          status_changed_at: '2023-05-18T19:28:36.307Z',
          status_changed_by: 'def2967b-f6fa-48a7-82f0-cf56ecd8b5a7',
          status: ExpenseStatusEnum.PENDING,
        },
        {
          status_changed_at: '2023-05-19T19:28:36.307Z',
          status_changed_by: 'def2967b-f6fa-48a7-82f0-cf56ecd8b5a7',
          status: ExpenseStatusEnum.APPROVED,
        },
      ],
    },
    {
      category: ExpenseCategoryEnum.DOMESTIC_TRAVEL,
      amount: {
        amount: 1234,
        currency: 'ZHF',
      },
      status: ExpenseStatusEnum.CHANGE_MADE,
      id: '7a634f20-74ee-4d0a-94b9-037420dc872f',
      employee_id: 'def2967b-f6fa-48a7-82f0-cf56ecd8b5a7',
      employee_name: 'Roy Testerton',
      approver_id: 'def2967b-f6fa-48a7-82f0-cf82ecd8b5b3',
      approver_name: 'Roy',
      title: 'Updated title',
      description: 'Updated description',
      date_spent: '2019-03-06T00:00:00.000Z',
      reported: false,
      status_history: [
        {
          status_changed_at: '2023-05-18T19:28:36.307Z',
          status_changed_by: 'def2967b-f6fa-48a7-82f0-cf56ecd8b5a7',
          status: ExpenseStatusEnum.PENDING,
        },
      ],
    },
    {
      category: ExpenseCategoryEnum.CLIENT_ENTERTAINMENT,
      amount: {
        amount: 90,
        currency: 'EUR',
      },
      status: ExpenseStatusEnum.PAID,
      id: 'da38c3d5-aec7-493c-8fdd-ba56476dbdc7',
      employee_id: 'def2967b-f6fa-48a7-82f0-cf56ecd8b5a7',
      employee_name: 'Roy Testing Sr. Testertonww',
      approver_id: 'adc8745b-f6fa-48a7-82f0-cf82ecd8b7t4',
      approver_name: 'Regular Admin',
      title: 'nn',
      description: 'nnn',
      date_spent: '2023-02-09T05:00:00.000Z',
      reported: false,
      status_history: [
        {
          status_changed_at: '2023-05-18T19:28:36.307Z',
          status_changed_by: 'def2967b-f6fa-48a7-82f0-cf56ecd8b5a7',
          status: ExpenseStatusEnum.PENDING,
        },
        {
          status_changed_at: '2023-05-18T19:28:36.307Z',
          status_changed_by: 'def2967b-f6fa-48a7-82f0-cf56ecd8b5a7',
          status: ExpenseStatusEnum.APPROVED,
        },
      ],
    },
    {
      category: ExpenseCategoryEnum.CLIENT_BILLABLE,
      amount: {
        amount: 1234.5,
        currency: 'EUR',
      },
      status: ExpenseStatusEnum.APPROVED,
      id: 'b2a90aae-ce2f-4696-aaa5-7a08de3ef066',
      employee_id: 'def2967b-f6fa-48a7-82f0-cf56ecd8b5a7',
      employee_name: 'Roy Testing Sr. Testerton',
      approver_id: 'adc8745b-f6fa-48a7-82f0-cf82ecd8b7t4',
      approver_name: 'Payroll Admin',
      title: 'regression1',
      description: 'regression1',
      date_spent: '2024-03-05T00:00:00.000Z',
      reported: false,
      status_history: [
        {
          status_changed_at: '2023-05-18T19:28:36.307Z',
          status_changed_by: 'def2967b-f6fa-48a7-82f0-cf56ecd8b5a7',
          status: ExpenseStatusEnum.PENDING,
        },
        {
          status_changed_at: '2023-05-18T19:28:36.307Z',
          status_changed_by: 'def2967b-f6fa-48a7-82f0-cf56ecd8b5a7',
          status: ExpenseStatusEnum.APPROVED,
        },
      ],
    },
    {
      category: ExpenseCategoryEnum.DOMESTIC_TRAVEL,
      amount: {
        amount: 10,
        currency: 'EUR',
      },
      status: ExpenseStatusEnum.INFO_NEEDED,
      id: '82f497c8-bd33-4124-96da-8b8bfa64bf25',
      employee_id: 'def2967b-f6fa-48a7-82f0-cf56ecd8b5a7',
      employee_name: 'Roy Testerton',
      approver_id: 'adc8745b-f6fa-48a7-82f0-cf82ecd8b7t4',
      approver_name: 'E2E Manager',
      title: 'test place',
      description: 'testing pdf upload',
      date_spent: '2022-05-05T00:00:00.000Z',
      reported: false,
      status_history: [
        {
          status_changed_at: '2023-05-18T19:28:36.307Z',
          status_changed_by: 'def2967b-f6fa-48a7-82f0-cf56ecd8b5a7',
          status: ExpenseStatusEnum.PENDING,
        },
      ],
    },
    {
      category: ExpenseCategoryEnum.TRAINING,
      amount: {
        amount: 972.8,
        currency: 'EUR',
      },
      status: ExpenseStatusEnum.REJECTED,
      id: '404a57ca-da84-4a7f-8c0b-8b40f4348ce2',
      employee_id: 'def2967b-f6fa-48a7-82f0-cf56ecd8b5a7',
      employee_name: 'Roy Testing Sr. Testertonww',
      approver_id: 'adc8745b-f6fa-48a7-82f0-cf82ecd8b7t4',
      approver_name: 'E2E Manager',
      title: 'Mews',
      description: 'Itemised Expense',
      date_spent: '2023-01-26T00:00:00.000Z',
      reported: false,
      status_history: [
        {
          status_changed_at: '2023-05-18T19:28:36.307Z',
          status_changed_by: 'def2967b-f6fa-48a7-82f0-cf56ecd8b5a7',
          status: ExpenseStatusEnum.REJECTED,
        },
      ],
    },
    {
      category: ExpenseCategoryEnum.CLIENT_BILLABLE,
      amount: {
        amount: 100,
        currency: 'EUR',
      },
      status: ExpenseStatusEnum.CHANGE_MADE,
      id: '16365e9a-100c-46ad-813d-74509ee7c82a',
      employee_id: 'def2967b-f6fa-48a7-82f0-cf56ecd8b5a7',
      employee_name: 'Roy Testing Sr. Testerton',
      approver_id: 'adc8745b-f6fa-48a7-82f0-cf82ecd8b7t4',
      approver_name: 'E2e Regular Manager',
      title: 'Testing',
      description: 'Joice testing expenses stuffs',
      date_spent: '2024-03-29T00:00:00.000Z',
      reported: false,
      status_history: [
        {
          status_changed_at: '2023-05-18T19:28:36.307Z',
          status_changed_by: 'def2967b-f6fa-48a7-82f0-cf56ecd8b5a7',
          status: ExpenseStatusEnum.PENDING,
        },
      ],
    },
    {
      category: ExpenseCategoryEnum.MILEAGE,
      amount: {
        amount: 132,
        currency: 'EUR',
      },
      status: ExpenseStatusEnum.APPROVED,
      id: '16365e9a-100c-46ad-813d-74509ee7c844',
      employee_id: 'def2967b-f6fa-48a7-82f0-cf56ecd8b5a7',
      employee_name: 'Roy Testing Sr. Testerton',
      approver_id: 'adc8745b-f6fa-48a7-82f0-cf82ecd8b7t4',
      approver_name: 'E2e Regular Manager',
      title: 'Reported Expense',
      description: 'This is a reported expense',
      date_spent: '2024-03-29T00:00:00.000Z',
      reported: false,
      status_history: [
        {
          status_changed_at: '2023-05-18T19:28:36.307Z',
          status_changed_by: 'def2967b-f6fa-48a7-82f0-cf56ecd8b5a7',
          status: ExpenseStatusEnum.PENDING,
        },
        {
          status_changed_at: '2023-05-18T19:28:36.307Z',
          status_changed_by: 'def2967b-f6fa-48a7-82f0-cf56ecd8b5a7',
          status: ExpenseStatusEnum.APPROVED,
        },
        {
          status_changed_at: '2023-05-22T19:28:36.307Z',
          status_changed_by: 'def2967b-f6fa-48a7-82f0-cf56ecd8b5a7',
          status: ExpenseStatusEnum.PROCESSED,
        },
      ],
    },
  ],
  size: 10,
  page: 1,
  pages: 1,
  total: 8,
};

export const DEFAULT_BULK_UPDATE_EXPENSES_RESPONSE: BulkUpdateExpensesResponseAPI =
  [
    {
      success: true,
      result: DEFAULT_EXPENSES.items[0],
    },
    {
      success: true,
      result: DEFAULT_EXPENSES.items[1],
    },
    {
      success: false,
      error: {
        name: 'Error',
        message: 'Error updating expense',
      },
      result: DEFAULT_EXPENSES.items[1],
    },
  ];

export const EXPENSES_CONFIG_DEFAULT: ExpensesConfigAPI = {
  editing_method: ExpensesEditingMethod.MANUAL,
};
